import React, { Component } from 'react';
import {
  initState,
  sendForm,
  setFieldActivationCode
} from 'mt-react-common/modules/coupons/reducers/activatedCouponForm/actions';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import {
  selectResultObject,
  selectFieldActivationCode
} from 'mt-react-common/modules/coupons/reducers/activatedCouponForm/selectors';
import {
  hasFieldError,
  selectFirstErrorByFiled
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import InfoMaterialContent from '../../InfoMaterials/InfoMaterialContent';

class ActivatedCouponForm extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      this.props.requestStatusData.codeResponse === 200
    ) {
      this.props.updateAccountInfo();
      this.props.initState();
    }
  }

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'activation_code':
        this.props.setFieldActivationCode(event.target.value);
        break;
      default:
        break;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendForm();
  };

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <React.Fragment>
            <small className="help-block">
              {this.props.selectFirstErrorByFiled(fieldName).message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        {this.props.requestStatusData.requestInProcess ||
        this.props.requestStatusData.codeResponse === 200 ? (
          <OpacityPreLoader />
        ) : null}
        <div className="row">
          <div className="col-sm-12 col-xs-24 m-b-20">
            <form onSubmit={this.handleSubmit}>
              <div
                className={`form-group ${
                  this.props.hasFieldError('activation_code') ? 'has-error' : ''
                }`}
              >
                <label className="control-label" htmlFor="inputCoupon">
                  {t('Ваш купон')}
                </label>
                <input
                  onChange={this.handleChangeField}
                  value={this.props.fieldActivationCode.value}
                  type="text"
                  className="form-control"
                  placeholder={t('Введите код вашего купона')}
                  name="activation_code"
                  id="inputCoupon"
                />
                {errorDesc('activation_code')}
              </div>
              <button type="submit" className="btn btn-primary btn-block">
                {t('Активировать купон')}
              </button>
            </form>
          </div>
          <div className="col-sm-12 col-xs-24">
            <div className="alert alert-warning m-b-0">
              <InfoMaterialContent id={'activated_coupon'} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ActivatedCouponForm.propTypes = {
  setFieldActivationCode: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  initState: PropTypes.func.isRequired,

  updateAccountInfo: PropTypes.func.isRequired,

  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,

  fieldActivationCode: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName),

  fieldActivationCode: selectFieldActivationCode(state, props.reducerName),

  resultObject: selectResultObject(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  setFieldActivationCode: value =>
    dispatch(setFieldActivationCode(props.reducerName, value)),
  sendForm: () => dispatch(sendForm(props.reducerName)),
  initState: () => dispatch(initState(props.reducerName)),
  updateAccountInfo: () => dispatch(sendGetAuthAccountDataRequest())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivatedCouponForm);



// WEBPACK FOOTER //
// ./src/components/Payments/ActivatedCouponForm/ActivatedCouponForm.js